import { z } from "zod";

export const emailRequestSchema = z.object({
  email: z
    .string()
    .min(1, "Email is required")
    .email("Enter a valid email")
    .max(255, "Email must be 255 characters or less"),
});

export type EmailRequestFormData = z.infer<typeof emailRequestSchema>;
